import React from 'react'
import DataTable from "react-data-table-component";
import Loader from '../../components/loader/loader';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import { Box, Paper, Tooltip } from "@mui/material";
import { Button, Form, Nav } from 'react-bootstrap'
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            fontWeight: '600',
            fontSize: '14px',

        },
    },
    cells: {
        style: {
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};

const Variant = ({ variantdata, loadingnested, statusActive, handleConfirm, checkUserPermissions, totalExpandedRows, limitvariant, handlePerRowsVariantChange, handlePageVariantChange, pagevariant }) => {
    console.log(loadingnested);
    const navigate = useNavigate();


    const columns = [
        {
            id: 'productname',
            name: 'Product Name',
            selector: (row) => row?.productName,
            cell: (row) => <Tooltip title={row?.productName} disableInteractive placement='top'><div className='text-truncate'>{row?.productName}</div></Tooltip>,
            width: "150px",

        },
        {
            id: 'category',
            name: 'Category',
            selector: (row) => row?.productSubcategory?.title,
            cell: (row) => <Tooltip title={row?.productSubcategory?.title} disableInteractive placement='top'><div className='text-truncate'>{row?.productSubcategory?.title}</div></Tooltip>,
            width: "120px",

        },
        {
            id: 'price',
            name: 'Price',
            selector: (row) => row?.price,
            cell: (row) => <Tooltip title={row?.price} disableInteractive placement='top'><div className='text-truncate'>{row?.price}</div></Tooltip>,
            width: "120px",

        },
        {
            id: 'discount',
            name: 'Discount',
            selector: (row) => row?.discountedPrice,
            cell: (row) => <Tooltip title={row?.discountedPrice} disableInteractive placement='top'><div className='text-truncate'>{row?.discountedPrice}</div></Tooltip>,
            width: "120px",

        },
        // {
        //     id: 'quantity',
        //     name: 'Quantity',
        //     selector: (row) => row?.usageLimit,
        //     cell: (row) => <Tooltip title={row?.usageLimit} disableInteractive placement='top'><div className='text-truncate'>{row?.usageLimit}</div></Tooltip>,
        //     width: "220px",

        // },
        {
            id: 'colors',
            name: 'Colors',
            selector: (row) => row?.color,
            cell: (row) => <Tooltip title={row?.color} disableInteractive placement='top'><div className='text-truncate color_code' style={{ width: "20px", height: "20px", border: '1px solid #EBEBEB', borderRadius: "50%", boxShadow: "0 0 12px -1px rgba(0, 0, 0, .11)", backgroundColor: row.color }}></div></Tooltip>,
            width: "120px",

        },

        {
            name: 'Status',
            selector: row => row.status,
            cell: (row) =>
                <div className='status_wrap_datatable'>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        checked={row.isActive === true}
                        onChange={() => statusActive(row?.id)}
                    />

                </div>,
            sortable: true,
            center: true,
            width: "120px",
        },

        {
            id: 'action',
            name: 'Action',
            cell: (row) =>
                <div>
                    {checkUserPermissions("manage_products") ? (
                        <div className="d-flex align-items-center">
                            <div className="d-flex flex-row align-items-center gap-3" role="button">
                                <Tooltip title="Edit" disableInteractive placement="top">
                                    <div className="edit_icon_bg" onClick={() => navigate("/edit-inventory/" + row.id, { state: { type: "variantType" } })}>
                                        <img
                                            src={editIcon}
                                            alt="Edit"
                                            className="edit_icon"
                                        />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Delete" disableInteractive placement="top">
                                    <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                                        <img
                                            src={deleteIcon}
                                            alt="Delete"
                                            className="delete_icon"
                                        />
                                    </div>
                                </Tooltip>

                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>,
            center: true,
            width: "120px",
        },
    ]





    return (
        <div>
            <Box className="products-and-options-nested" sx={{ mt: 1 }}>
                <Paper square>
                    <div>
                        <DataTable
                            columns={columns}
                            data={variantdata}
                            progressPending={loadingnested}
                            progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                            pagination
                            paginationServer
                            paginationTotalRows={totalExpandedRows}
                            paginationPerPage={limitvariant}
                            onChangeRowsPerPage={handlePerRowsVariantChange}
                            onChangePage={handlePageVariantChange}
                            currentPage={pagevariant}
                            customStyles={queueDatatableCustomStyles}
                        />
                    </div>
                </Paper>
            </Box>

        </div>
    )
}

export default Variant